<template>
  <el-popover trigger="hover" popper-class="popover-select-box">
    <div class="select-box">
      <div class="flex">
        <slot/>
      </div>

      <template v-if="name">
        <router-link
          v-if="to.name"
          class="select-footer"
          :to="to"
        >
          <v-icon :name="icon"/>
          {{ name }}
        </router-link>
        <div
          v-else
          class="select-footer"
          @click="handleClick"
        >
          <v-icon :name="icon"/>
          {{ name }}
        </div>
      </template>
    </div>
    <el-button class="list-button-more" slot="reference" icon="el-icon-more" size="small" plain/>
  </el-popover>
</template>

<script>
import message from "@/utils/message";

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'bin',
    },
    to: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
  methods: {
    async handleClick() {
      if (this.isLoading) return;

      if (this.message) {
        const isCancel = await message({ message: this.message });
        if (isCancel) return;
      }

      this.$emit('click');
    },
  },
};
</script>
